module.exports = __webpack_public_path__ + "static/img/tdf-logo3.9c53a3a.png";